export enum AmendServiceEndpoints {
    GetAmendData = '/v1/amend',
    PostAmendNoAdminFee = '/v1/amend/process-amend-no-admin-fee',
    PostAmend = '/v1/amend/process-amend',
    PostUpdateOccupantDetails = '/v1/amend/dual-occupant',
}
